/**
 * For a given prompt, checks if its teacher id has a match from a collection of teacher objects
 * @param {object} prompt
 * @param {array} teachers
 * @returns {boolean}
 */
const promptMatchesTeachers = (prompt, teachers) => {
  return (
    teachers && teachers.some((teacher) => teacher?.id === prompt?.teacher?.id)
  );
};

export default promptMatchesTeachers;
